const adornmentStyles = {
  root: {
    alignSelf: 'center'
  }
};

export default adornmentStyles;
